<template>
  <div class="grey lighten-4">
    <div class="footer-table">
      <div style="width: 30%"></div>
      <div class="fee d-flex justify-end" md="2"></div>
      <div class="fee d-flex justify-end" md="2"></div>
      <div class="d-flex justify-end" md="2">
        <span class="fee">{{ totalAmountDebt | price }}</span>
      </div>
      <div style="width: 10%" class="d-flex justify-end" md="2"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      totalAmountPaid: 'studentDebt/totalAmountPaid',
      totalAmountDebt: 'studentDebt/totalAmountDebt',
    }),
  },
}
</script>
<style lang="scss" scoped>
.footer-table {
  display: flex;
  height: 60px;
  align-items: center;
}

.footer-table > div {
  width: 20%;
  font-size: 14px;
  margin-right: 10px;
}

.fee {
  color: #fd6b6b !important;
  font-weight: 500;
}
</style>
